/**
 * Loading Fallback Component
 * 
 * Displayed while lazy-loaded components are being fetched
 */

interface LoadingFallbackProps {
  fullScreen?: boolean;
  message?: string;
}

export function LoadingFallback({ fullScreen = false, message = 'Loading...' }: LoadingFallbackProps) {
  if (fullScreen) {
    return (
      <div className="min-h-screen bg-neutral-900 flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="w-16 h-16 mx-auto relative">
            <div className="absolute inset-0 border-4 border-purple-500/30 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-purple-500 rounded-full border-t-transparent animate-spin"></div>
          </div>
          <p className="text-sm text-neutral-400">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-8">
      <div className="text-center space-y-3">
        <div className="w-12 h-12 mx-auto relative">
          <div className="absolute inset-0 border-3 border-purple-500/30 rounded-full"></div>
          <div className="absolute inset-0 border-3 border-purple-500 rounded-full border-t-transparent animate-spin"></div>
        </div>
        <p className="text-sm text-neutral-400">{message}</p>
      </div>
    </div>
  );
}

// Minimal inline loading for small components
export function InlineLoader() {
  return (
    <div className="inline-flex items-center gap-2">
      <div className="w-4 h-4 border-2 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
      <span className="text-sm text-neutral-400">Loading...</span>
    </div>
  );
}